import { render } from "./goRinSyo0004.vue?vue&type=template&id=d57cabf0"
const script = {}

import "./goRinSyo0004.vue?vue&type=style&index=0&id=d57cabf0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__